import React from 'react';

export default function DotCorner() {
  return (
    <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 42.5C21.3807 42.5 22.5 41.3807 22.5 40C22.5 38.6193 21.3807 37.5 20 37.5C18.6193 37.5 17.5 38.6193 17.5 40C17.5 41.3807 18.6193 42.5 20 42.5Z" />
      <path d="M30 42.5C31.3807 42.5 32.5 41.3807 32.5 40C32.5 38.6193 31.3807 37.5 30 37.5C28.6193 37.5 27.5 38.6193 27.5 40C27.5 41.3807 28.6193 42.5 30 42.5Z" />
      <path d="M30 32.5C31.3807 32.5 32.5 31.3807 32.5 30C32.5 28.6193 31.3807 27.5 30 27.5C28.6193 27.5 27.5 28.6193 27.5 30C27.5 31.3807 28.6193 32.5 30 32.5Z" />
      <path d="M40 22.5C41.3807 22.5 42.5 21.3807 42.5 20C42.5 18.6193 41.3807 17.5 40 17.5C38.6193 17.5 37.5 18.6193 37.5 20C37.5 21.3807 38.6193 22.5 40 22.5Z" />
      <path d="M40 42.5C41.3807 42.5 42.5 41.3807 42.5 40C42.5 38.6193 41.3807 37.5 40 37.5C38.6193 37.5 37.5 38.6193 37.5 40C37.5 41.3807 38.6193 42.5 40 42.5Z" />
      <path d="M40 32.5C41.3807 32.5 42.5 31.3807 42.5 30C42.5 28.6193 41.3807 27.5 40 27.5C38.6193 27.5 37.5 28.6193 37.5 30C37.5 31.3807 38.6193 32.5 40 32.5Z" />
    </svg>
  );
}
